<!-- This example requires Tailwind CSS v2.0+ -->
<template>
    <!-- Global notification live region, render this permanently at the end of the document -->
    <div aria-live="assertive" class="fixed inset-0 flex items-end pointer-events-none sm:p-6 sm:items-end">
        <div class="w-full flex flex-col items-center space-y-4 sm:items-end">
            <!-- Notification panel, dynamically insert this into the live region when it needs to be displayed -->
            <transition enter-active-class="transform ease-out duration-300 transition" enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2" enter-to-class="translate-y-0 opacity-100 sm:translate-x-0" leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100" leave-to-class="opacity-0">
                <div v-if="open" class="w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden">
                    <div class="p-4">
                        <div class="flex items-start">
                            <div class="flex-shrink-0">
                                <InformationCircleIcon v-if="type == 'info'" class="h-6 w-6 text-blue-400" aria-hidden="true" />
                                <CheckCircleIcon v-if="type == 'success'" class="h-6 w-6 text-green-400" aria-hidden="true" />
                                <ExclamationIcon v-if="type == 'warning'" class="h-6 w-6 text-yellow-400" aria-hidden="true" />
                                <ExclamationCircleIcon v-if="type == 'error'" class="h-6 w-6 text-red-400" aria-hidden="true" />
                            </div>
                            <div class="ml-3 w-0 flex-1 pt-0.5">
                                <p class="text-sm font-medium text-gray-900">Ta strona używa plików cookies</p>
                                <p class="mt-1 text-sm text-gray-500">Aby świadczyć usługi na najwyższym poziomie. Korzystanie ze strony oznacza, że zgadzasz się na ich użycie zgodnie z ustawieniami przeglądarki. Więcej informacji znajdziesz w naszej <a href="#">polityce prywatności.</a></p>
                            </div>
                            <div class="ml-4 flex-shrink-0 flex">
                                <button @click="close()" class="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                    <span class="sr-only">Close</span>
                                    <XIcon class="h-5 w-5" aria-hidden="true" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import { ref } from 'vue';
import {
    CheckCircleIcon,
    ExclamationIcon,
    ExclamationCircleIcon,
    InformationCircleIcon
} from '@heroicons/vue/outline'
import { XIcon } from '@heroicons/vue/solid'

export default {
    name: "BottomBar",
    components: {
        CheckCircleIcon,
        XIcon,
        ExclamationIcon,
        ExclamationCircleIcon,
        InformationCircleIcon,
    },
    data: () => ({
        open: true
    }),
    setup() {
        let open = ref(true);
        if (localStorage.getItem('hideBottomBar') === 'hide') {
            open.value = false;
        }

        return { open }
    },
    methods: {
        close() {
            this.open = false;
            localStorage.setItem('hideBottomBar', 'hide');
        }
    }
}
</script>
